import {HiMenu} from 'react-icons/hi';

const MenuIcon = (props) => {
    return <HiMenu style={props.style ? props.style :  {color: 'black', fontSize: '1rem'}} />
}

export default MenuIcon;